export default "assets/images/0beac2cb41dfab43ddfd9df80b32b85d.png";